
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/snowboard-shipping",
      function () {
        return require("private-next-pages/snowboard-shipping/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/snowboard-shipping"])
      });
    }
  